import { PulseTourConfig, PulseTourStep } from '@go-modules/services/go-pulse-tour/go-pulse-tour.service';

/**
 * Activity Task Tour for Learners
 *
 * This tour guides learners through their activity tasks by pulsing
 * the first incomplete task in the task pane.
 *
 * Tour Logic:
 * - If all tasks are complete → don't start (can appear on another activity)
 * - If user IS on the first incomplete task → no pulse (they're in the right place)
 * - If user is NOT on the first incomplete task → pulse it
 * - When user clicks pulsing task → pulse the next incomplete task
 * - Tour completes when user clicks the LAST incomplete task (only 1 remaining)
 */

export const ACTIVITY_TASK_LEARNER_TOUR_KEY = 'activity-task-learner-tour';

export const ACTIVITY_TASK_TOUR_SELECTORS = {
	taskItemIncomplete: '[data-tour="task-item-incomplete"]'
} as const;

/**
 * Creates a step to pulse the first incomplete task in the task pane
 */
export function createPulseIncompleteTaskStep (): PulseTourStep {
	return {
		completeSelectors: [ACTIVITY_TASK_TOUR_SELECTORS.taskItemIncomplete],
		pulse: {
			selectors: [ACTIVITY_TASK_TOUR_SELECTORS.taskItemIncomplete]
		}
	};
}

/**
 * Creates the tour configuration.
 *
 * @param steps - Steps for the tour (typically 1 step to pulse first incomplete task)
 */
export function createActivityTaskLearnerTour (steps: PulseTourStep[]): PulseTourConfig {
	return {
		viewTrackKey: ACTIVITY_TASK_LEARNER_TOUR_KEY,
		steps,
		constraints: {
			tourStartDate: new Date('2026-03-01'),
			isOnboarding: false
		},
		// isDynamic: true prevents auto-completion when clicking the pulsed task
		// We manually complete the tour when the user clicks the LAST incomplete task
		isDynamic: true
	};
}
